import { render, staticRenderFns } from "./PageImpersonate.vue?vue&type=template&id=6cc2fbc8&"
import script from "./PageImpersonate.vue?vue&type=script&lang=js&"
export * from "./PageImpersonate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports